import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    image: 'h-full w-full object-cover'
  }
});
